import Request from '../baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _createCampaign = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/loyalty-campaigns`,
    payload,
    config
  )
}

const _getCampaigns = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/loyalty-campaigns?${params.q}`,
    config
  )
}

const _deleteCampaign = campaignId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/loyalty-campaigns/${campaignId}`, config)
}

const _getCampaign = campaignId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/loyalty-campaigns/${campaignId}`, config)
}

const _updateCampaign = (campaign) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/loyalty-campaigns/${campaign._id}`, campaign, config)
}

export default {
  createCampaign: _createCampaign,
  getCampaigns: _getCampaigns,
  deleteCampaign: _deleteCampaign,
  getCampaign: _getCampaign,
  updateCampaign: _updateCampaign
}